<h2 mat-dialog-title class="bgDialogHeader text-center">Guide
  <div class="pull-right">
    <a class="boxclose" (click)="onNoClick()"></a>
  </div>
</h2>
<iframe [src]="fileName" width="100%" height="90%">
</iframe>